import { useState, useEffect } from "react";
import { CustomTable } from "../../../../components/Table";
import { Breadcrum } from "../../../../components/Layout/breadcrum";
import { Navigate, useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/Button";
import { SearchBox } from "../../../../components/SearchBox";
import { createColumnHelper } from "@tanstack/react-table";
import EyeIcon from "../../../../assets/Login/eye.svg";
import { toast } from "react-hot-toast";
import { POST } from "../../../../utils/webService";
import CenterModal from "../../../../components/CustomModal/customCenterModal";
import DeleteConfirmModale from "./deleteConfirmationModal";
import {
  POST_GET_ALL_USER_DATA,
  POST_DELETE_USER_DATA,
} from "../../../../utils/ApiUrls";
import { useSelector } from "react-redux";
import AccessDenied from "../../../../components/AccessDenied";
import { checkPageAuthorized } from "../../../../redux/reducers/role";
import OneButton from "../../../../components/Button/OneButton";
import { useMediaQuery } from "react-responsive";

function UserManagement() {
  const navigate = useNavigate();
  const roles = useSelector((state: any) => state?.roles);
  const isDesktopView = useMediaQuery({ minWidth: 1024 });
  // const isActive = roles.roles?.[0]?.menu?.[8]?.menu?.[0]?.pages?.[2]?.isActive;
  const isActive = checkPageAuthorized("User Management");

  const [usersData, setUsersData] = useState([]);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [isModalOpen, setIsModalOpen]: any = useState(false);
  const [deleteUser, setDeleteUser]: any = useState("");

  const Buttons = (className?: string, usersData?: any) => {
    return (
      <div
        className={
          className
            ? className
            : `lg:flex lg:flex-row-reverse grid-cols-4 gap-x-2 mt-4 lg:mt-0 h-[54px] items-center`
        }
      >
        <div className="flex">
          <OneButton
            className="lg:px-2 lg:py-4 lg:font-semibold lg:text-[14px]"
            text="ADD ROLE"
            onClick={() => navigate("/settings/role-management/add-role")}
            variant="primary"
          />
          {/* <CustomButton
            className="lg:px-2 lg:py-4 lg:font-semibold lg:text-[14px]"
            text="ADD ROLE"
            onClick={() => navigate("/settings/role-management/add-role")}
          /> */}

          <OneButton
            className="lg:px-2 lg:py-4 lg:font-semibold lg:text-[14px] ml-4"
            text="ADD USER"
            onClick={() => navigate("/settings/user-management/add-user")}
            variant="primary"
          />
          {/* <CustomButton
            className="lg:px-2 lg:py-4 lg:font-semibold lg:text-[14px] ml-4"
            text="ADD USER"
            onClick={() => navigate("/settings/user-management/add-user")}
          /> */}
        </div>
      </div>
    );
  };

  const columnsHelper = createColumnHelper<any>();
  const columns = [
    columnsHelper.accessor("sellerId", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>User ID</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => info.getValue(),
    }),
    columnsHelper.accessor("firstName", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>User Name</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => {
        const data = info.cell.row.original;
        return (
          <div>
            {data.firstName} {data.lastName}
          </div>
        );
      },
    }),
    columnsHelper.accessor("email", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>Email</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => info.getValue(),
    }),
    columnsHelper.accessor("contactNumber", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>Mobile</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => info.getValue(),
    }),

    // columnsHelper.accessor("roleId", {
    //   header: () => {
    //     return (
    //       <div>
    //         <div className="flex justify-between items-center">
    //           <h1>Role Id</h1>
    //           <div className="cursor-pointer"></div>
    //         </div>
    //       </div>
    //     );
    //   },
    //   cell: (info: any) => info.getValue(),
    // }),
    columnsHelper.accessor("roleName", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>Role Name</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => info.getValue(),
    }),
    columnsHelper.accessor("isActive", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1>User Status</h1>
            <div className="cursor-pointer"></div>
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <>
            <p>
              {info.getValue() ? (
                <span className="text-green-600">Active</span>
              ) : (
                "Not Active"
              )}
            </p>
          </>
        );
      },
    }),
    columnsHelper.accessor("actions", {
      header: "Actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-center items-center">
            <div>
              <OneButton
                text={"UPDATE"}
                onClick={() =>
                  navigate(`/settings/user-management/update-user`, {
                    state: { data: row?.original },
                  })
                }
                variant="primary"
              />
              {/* <CustomButton
                text={"UPDATE"}
                onClick={() =>
                  navigate(`/settings/user-management/update-user`, {
                    state: { data: row?.original },
                  })
                }
              /> */}
            </div>

            <div className="border mx-2">
              <OneButton
                text={"DELETE"}
                onClick={() => deleteRoleModal(row?.original)}
                variant="primary"
              />
              {/* <CustomButton
                text={"DELETE"}
                onClick={() => deleteRoleModal(row?.original)}
              /> */}
            </div>
          </div>
        );
      },
    }),
  ];

  // get users list from api
  const getUsersData = async () => {
    try {
      const { data }: any = await POST(POST_GET_ALL_USER_DATA, {});

      if (data?.success) {
        setUsersData(data?.data || []);
        setTotalItemCount(data?.data?.[0]?.totalCount || 100);
      } else {
        toast.error(data?.message || "Failed to fetch users");
      }
    } catch (error) {
      setUsersData([]);
    }
  };

  // delete role api call
  const deleteUserApiCall = async (payload: any) => {
    try {
      const reqBody = {
        sellerId: payload?.sellerId || "N/A",
      };

      const { data } = await POST(POST_DELETE_USER_DATA, reqBody);

      if (data?.success) {
        setIsModalOpen(false);
        getUsersData();
      } else {
        toast.error(data?.message || "N/A");
      }
    } catch (error) {
      toast.error("Failed to delete role");
    }
  };

  const deleteRoleModal = async (data: any) => {
    try {
      setDeleteUser(data || {});
      setIsModalOpen(true);
    } catch (error) {
      toast.error("Failed to delete the role");
    }
  };

  useEffect(() => {
    getUsersData();
  }, []);

  return (
    <>
      {isActive ? (
        <div>
          <Breadcrum
            label="User Management"
            component={Buttons("", usersData)}
          />
          <div className=" my-3 mx-6">
            {/* <div className=" flex justify-end">
              <div className="grid grid-cols-3 gap-x-2 lg:flex ">
                <div>
                  <SearchBox label="Search" value="" onChange={() => {}} />
                </div>
                <div
                  className="flex justify-between items-center p-2 gap-x-2"
                  // onClick={() => setFilterModal(true)}
                >
                  <span className="text-[#004EFF] text-[14px] font-semibold">
                    FILTER
                  </span>
                </div>
              </div>
            </div> */}

            <div className=" mt-6">
              {isDesktopView ? (
                <CustomTable rowData={usersData || []} columnsData={columns || []} />
              ) : (
                <div className="space-y-4">
                  {(usersData || []).map((data: any, index: number) => (
                    <div
                      key={data?.sellerId || data?.email || index}
                      className="rounded-lg border border-[#E8E8E8] bg-white p-4 shadow-sm"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <div className="break-words text-[16px] font-semibold text-[#1C1C1C]">
                            {`${data?.firstName || ""} ${data?.lastName || ""}`.trim() ||
                              "-"}
                          </div>
                          <div className="mt-1 break-words text-[12px] text-[#777777]">
                            User ID: {data?.sellerId || "-"}
                          </div>
                        </div>
                        <div className="shrink-0">
                          <img src={EyeIcon} alt="eye" />
                        </div>
                      </div>

                      <div className="mt-4 grid grid-cols-1 gap-y-2 text-[13px] text-[#1C1C1C] sm:grid-cols-2 sm:gap-x-4">
                        <div className="min-w-0">
                          <span className="text-[#777777]">User Name: </span>
                          <span className="break-words">
                            {`${data?.firstName || ""} ${data?.lastName || ""}`.trim() ||
                              "-"}
                          </span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Email: </span>
                          <span className="break-words">{data?.email || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Mobile: </span>
                          <span>{data?.contactNumber || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">Role Name: </span>
                          <span className="break-words">{data?.roleName || "-"}</span>
                        </div>
                        <div className="min-w-0">
                          <span className="text-[#777777]">User Status: </span>
                          <span className={data?.isActive ? "text-green-600" : ""}>
                            {data?.isActive ? "Active" : "Not Active"}
                          </span>
                        </div>
                      </div>

                      <div className="mt-4 flex flex-col gap-3 sm:flex-row">
                        <OneButton
                          text="UPDATE"
                          onClick={() =>
                            navigate(`/settings/user-management/update-user`, {
                              state: { data },
                            })
                          }
                          variant="primary"
                          className="w-full sm:w-auto"
                        />
                        <OneButton
                          text="DELETE"
                          onClick={() => deleteRoleModal(data)}
                          variant="primary"
                          className="w-full sm:w-auto"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <CenterModal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
              className="!h-[340px] !w-[400px] md:!w-[480px]"
            >
              <DeleteConfirmModale
                userInfo={deleteUser}
                setIsModalOpen={setIsModalOpen}
                deleteRoleApiCall={deleteUserApiCall}
                title="user"
              />
            </CenterModal>
          </div>
        </div>
      ) : (
        <div>
          <AccessDenied />
        </div>
      )}
    </>
  );
}

export default UserManagement;
